import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core';
import { otpVerificadaGuard } from './core/guards/otp.guard';
import { CambiarContraseniaComponent } from './features/cambiar-contrasenia/cambiar-contrasenia.component';
import { ScheduleComponent } from './shared/schedule/schedule.component';
import { Roles } from './models';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'ingresar',
    pathMatch: 'full',
  },
  {
    title: 'Bienvenidos al SIGD Contreras Hnos.',
    path: 'ingresar',
    loadChildren: () =>
      import('./features/login/login.module').then((m) => m.LoginModule),
  },
  {
    title: 'Bienvenidos al SIGD Contreras Hnos.',
    path: '',
    loadChildren: () =>
      import('./features/home-page/home-page.module').then(
        (m) => m.HomePageModule,
      ),
    canActivate: [authGuard, otpVerificadaGuard],
  },
  {
    title: 'Bienvenidos al SIGD Contreras Hnos.',
    path: '',
    loadChildren: () =>
      import('./features/hse/hse.module').then((m) => m.HseModule),
    canActivate: [authGuard, otpVerificadaGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/home/home.module').then((m) => m.HomeModule),
    canActivate: [authGuard, otpVerificadaGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/administracion/administracion.module').then(
        (m) => m.AdministracionModule,
      ),
    canActivate: [authGuard, otpVerificadaGuard],
  },
  {
    title: 'Cambiar contraseña',
    path: 'clave',
    component: CambiarContraseniaComponent,
    canActivate: [authGuard],
  },
  {
    path: 'certificados',
    loadChildren: () =>
      import('./features/certificados/certificados.module').then(
        (m) => m.CertificadosModule,
      ),
  },
  {
    path: 'policies',
    loadChildren: () =>
      import('./features/policies/policies.module').then(
        (m) => m.PoliciesModule,
      ),
  },
  {
    path: 'cookies',
    loadChildren: () =>
      import('./features/cookies/cookies.module').then((m) => m.CookiesModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/ticket/ticket.module').then((m) => m.TicketModule),
  },
  {
    path: 'calendario',
    component: ScheduleComponent,
    canActivate: [authGuard, otpVerificadaGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
